<template>
  <li v-if="submenu" class="nav-item">
    <a
      class="nav-link py-2 mb-1 fs-5 cursor-pointer item-action" :title="title"
      :class="{'active': $route.path.includes(group)}"
      data-bs-toggle="offcanvas" :data-bs-target="`#canvas_${title}`"
    >
      <i class="bi" :class="icon" />
    </a>
  </li>
  <li v-else class="nav-item">
    <router-link :to="to" class="nav-link py-2 mb-1 fs-5" :title="title" active-class="active">
      <i class="bi" :class="icon" />
    </router-link>
  </li>
  <SubMenu v-if="submenu" :submenu="submenu" :title="title" />
</template>

<script>
import SubMenu from './SideBarSubMenu.vue';

export default {
  components: { SubMenu },
  props: {
    to: { type: String, default: null },
    icon: { type: String, required: true },
    title: { type: String, required: true },
    group: { type: String, default: null },
    submenu: { type: Array, default: null },
  },
};
</script>
